import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  GridContainer,
  CellContainer,
  GridRow
} from './styled';
import StatusCell from '../status-cell';
import { mapOrder, getStudentInfo, getFirstStatusOccurrences } from './grid-util';
import GridHeader from './grid-header';
import { SCHEDULED_ASSIGN, statusCodes } from '../status-cell/utils';

const Grid = (props) => {
  const { learningJourneyIds } = props;
  let { assignmentStatuses } = useSelector(state => state.UPFAssignReducer);
  const { sortedStudents, selectedStudentIds, selectedTopics } =
    useSelector(state => state.UPFAssignReducer);
  const filteredStudentsIds = sortedStudents.map(student => student.id) || [];

  assignmentStatuses = mapOrder(assignmentStatuses, sortedStudents.map(student => student.id));

  return (
    <GridContainer >
      <GridHeader learningJourneyIds={learningJourneyIds} />
      <CellContainer>
        {
          filteredStudentsIds.map((studentProfileId) => {
            const firstStatusOccurrences =
              getFirstStatusOccurrences(selectedTopics, assignmentStatuses, studentProfileId);
            return (<GridRow key={studentProfileId} isSelected={selectedStudentIds.includes(studentProfileId)}>
              {learningJourneyIds.map((LearningJourneyId) => {
                const studentInfo = getStudentInfo(assignmentStatuses, studentProfileId, LearningJourneyId) || {};
                return (
                  <StatusCell
                    i18n={props.i18n}
                    id={`${LearningJourneyId}_${studentProfileId}`}
                    key={`${LearningJourneyId}_${studentProfileId}`}
                    studentInfo={studentInfo}
                    isSelected={selectedStudentIds.includes(studentProfileId)}
                    isFirstOfStatus={firstStatusOccurrences[studentInfo.studentStatus] === LearningJourneyId}
                    showSchedule={!!firstStatusOccurrences[statusCodes[SCHEDULED_ASSIGN]]}
                  />
                );
              })
              }
            </GridRow>);
          })
        }
      </CellContainer>
    </GridContainer>
  );
};

Grid.propTypes = {
  learningJourneyIds: PropTypes.array,
  i18n: PropTypes.object
};

Grid.defaultProps = {
  learningJourneyIds: []
};

Grid.whyDidYouRender = false;

export default Grid;
